{
    "NAME": "Lista de gerenciamento de logs",
    "LogManagementList_Column_Name": "Arquivo de registro",
    "LogManagementList_Column_ClassName": "Para a aula",
    "LogManagementList_Column_FileName": "Nome do arquivo",
    "LogManagementList_Column_FileSize": "Tamanho do arquivo",
    "LogManagementList_Column_Status": "Status",
    "LogManagementList_Status_Running": "Correndo",
    "LogManagementList_Status_NotRunning": "Não está funcionando",
    "LogManagementList_Action_Start": "Começar",
    "LogManagementList_Action_Stop": "Parar",
    "LogManagementList_Action_Reset": "Reiniciar",
    "LogManagementList_Action_Download": "Download",
    "LogManagementList_SearchPlaceholder": "[Arquivo de registro]",
    "LogManagementList_Empty": "Nenhum item de registro está sendo exibido no momento, o que provavelmente indica um problema crítico de inicialização do aplicativo ou de um componente interno.",
    "LogManagementList_Confirm_ResetTitle": "Redefinir arquivos de registro",
    "LogManagementList_Confirm_ResetBody": "Aviso: Optar por redefinir os itens do arquivo de log excluirá os arquivos correspondentes, uma operação irreversível.",
    "LogManagementList_Confirm_StopTitle": "Parar registro",
    "LogManagementList_Confirm_StopBody": "A opção de interromper temporariamente a geração de registros nos arquivos de log selecionados deve ser realizada apenas quando for necessário congelar os arquivos correspondentes em situações específicas.",
    "LogManagementList_Confirm_Generic": "Tem certeza de que deseja continuar e executar a ação selecionada?"
}